import { DitherMark, SwimmingFish } from '../components/pages/HomePage'

export default function HomePage() {
  return (
    <div className="min-h-[62svh]">
      <h1 className="sr-only">Candlefish</h1>
      <DitherMark />
      <SwimmingFish />
    </div>
  )
}
